/* @flow */
import * as React from 'react';

import { Button, ButtonIcon, Footer, ProcModal } from '@sonyged/ext-proc';

import ImageSelection from './ImageSelection';

type Props = {
  title?: string,
  value: number,
  images: Array<string>,
  labels: Array<string>,
  onSelected: Function,
  innerRef?: React.Ref<any>,
  rootNodeId?: string,
  blankLabel?: string,
};

type State = {
  isOpened: boolean,
};

export default class ProcSelect extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isOpened: false,
    };
  }

  render() {
    // eslint-disable-next-line
    const { innerRef, blankLabel, value, images, labels, onSelected, rootNodeId, ...rest } = this.props;

    let val = labels.find((_, index) => index === value);
    let label = val ? <span>{val}</span> : <span className="primary120-color">{blankLabel || 'えらぶ'}</span>;

    return (
      <div
        {...rest}
        className={'proc-select proc-small-font'}
        onClick={this.state.isOpened ? null : this._onClick.bind(this)}
        ref={innerRef}
      >
        <div className={'w100 ellipsis'}>{label}</div>
        <i className={'icon-proc-dropdown'} />
        <ProcModal isOpened={this.state.isOpened} rootNodeId={rootNodeId || 'proc-page-root'}>
          <div key="modal" className={'proc-modal proc-modal--hint'}>
            <div className="proc-modal-container">
              <div className={'proc-modal-header'}>{this.props.title || 'えらぶ'}</div>
              <div className={'proc-modal-contents'}>
                <ImageSelection
                  value={value}
                  images={images}
                  labels={labels}
                  onSelected={this._onSelected.bind(this)}
                />
              </div>
            </div>

            <Footer.nav
              shadow={false}
              navItem={
                <Button.dark className="modal-close-se" onClick={this._onClose.bind(this)}>
                  <ButtonIcon.close />
                </Button.dark>
              }
            />
          </div>
        </ProcModal>
      </div>
    );
  }

  _onClick() {
    this.setState({ isOpened: true });
  }

  _onClose() {
    this.setState({ isOpened: false });
  }

  _onSelected(v: any) {
    this.setState({ isOpened: false });
    this.props.onSelected(v);
  }
}
